import * as Yup from 'yup';

const stepTwoSchema = Yup.array().of(
  Yup.object().shape({
    degree: Yup.mixed().required('This field is required'),
    school: Yup.mixed().required('This field is required'),
    major: Yup.mixed().required('This field is required'),
    gpa: Yup.mixed().required('This field is required'),
    gpaNot4: Yup.boolean(),
    gpaNotes: Yup.string(),
    startMonth: Yup.mixed().required('This field is required'),
    startYear: Yup.mixed().required('This field is required'),
    endYear: Yup.mixed().required('This field is required'),
    endMonth: Yup.mixed().required('This field is required').test('is-after-start', 'End date must be after start date', function (currentValue) {
      if (!this.parent.endYear || !this.parent.startYear || !this.parent.startMonth) {
        return false;
      }

      if (this.parent.endYear.value < this.parent.startYear.value) {
        return false;
      }

      return !(this.parent.endYear.value === this.parent.startYear.value && currentValue.value < this.parent.startMonth.value);
    }),
    present: Yup.boolean(),
  })
);

export default stepTwoSchema;
